import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetBreedersFarmsAction} from '../action';

function* execute({payload}: GetBreedersFarmsAction): SagaIterator {
    const response = yield* call(Api.findAllByBreederIdForPrincipal, payload);

    if (response.isSuccess) {
        yield* put(adminAction.setBreedersFarms(response.data));
    } else {
        yield putAll(showBeError(response, t('userDetail')('farmOptionsLoading')));
    }
}
/** Runs the admin saga that loads farm options for breeder management. */
export function* getManagementBreederFarmsSaga(): SagaIterator {
    yield takeLatestF('admin/GET_BREEDERS_FARMS', execute);
}
